import { ValueGetterParams } from 'ag-grid-enterprise';
import { DocumentReader } from 'src/app/modules/core/store/models';

export const arrayValueGetter = (params: ValueGetterParams) => {
  const field = params.colDef.cellRendererParams.schemaField;

  const reader = new DocumentReader(params.data);
  const fieldValue = reader.getFieldValue(field.systemName);

  if (!!fieldValue) {
    return fieldValue.join(',');
  }

  return '';
};
